export const VINCULARCORREO = "vincular correo";
export const VERPLANES = "ver planes";
export const SELECTCONTENT = "select_content";
export const INICIO = "inicio";
export const MODULENAME = 'recuerda que por ser cliente telmex disfrutas claro video sin costo';



// WEBPACK FOOTER //
// ./src/components/centerNotification/constants.js